import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { LANGUAGES } from "@/i18n";

const LanguageSwitcher = ({ compact = true }: { compact?: boolean }) => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const current = LANGUAGES.find((l) => l.code === i18n.language.split("-")[0]) ?? LANGUAGES[0];

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label={`${current.label} — ${t("languageSwitcher.label")}`}
        className="inline-flex items-center gap-1.5 border border-border px-2.5 py-2 text-[12px] font-medium tracking-tight text-foreground transition-colors hover:border-foreground/40"
      >
        <Globe className="h-3.5 w-3.5" strokeWidth={1.5} />
        {compact ? current.label : current.name}
      </button>
      {open && (
        <div className="absolute right-0 top-full z-50 mt-1 w-36 border border-border bg-background shadow-lg">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className="flex w-full items-center justify-between px-3 py-2 text-left text-[13px] text-foreground transition-colors hover:bg-muted"
            >
              <span>{l.name}</span>
              {current.code === l.code && <Check className="h-3.5 w-3.5 text-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;